import { motion } from "framer-motion";
import { Home, Building2, PanelTop, HardHat, Car, Check, ArrowUpRight } from "lucide-react";

const IMG = {
  logement:
    "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxicmlnaHQlMjBjbGVhbiUyMGFyY2hpdGVjdHVyYWwlMjBpbnRlcmlvciUyMGxpdmluZyUyMHJvb218ZW58MHx8fHwxNzkzMTg2MjM4fDA&ixlib=rb-4.1.0&q=80&w=900",
  vitres:
    "https://images.pexels.com/photos/16898979/pexels-photo-16898979.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  locaux:
    "https://images.pexels.com/photos/245219/pexels-photo-245219.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  auto: "https://images.unsplash.com/photo-1605437241278-c1806d14a4d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHxfHxjYXIlMjBpbnRlcmlvciUyMGRldGFpbGluZyUyMHByaXN0aW5lJTIwbGVhdGhlciUyMHNlYXRzfGVufDB8fHx8MTc5MzE4ODgzOHww&ixlib=rb-4.1.0&q=80&w=900",
  chantier:
    "https://images.unsplash.com/photo-1721395286594-8913b06056eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxyZW5vdmF0ZWQlMjBlbXB0eSUyMG1vZGVybiUyBhcGFydG1lbnQlMjBpbnRlcmlvciUyMGxhbmRzY2FwZXxlbnwwfHx8fDE3OTMxODg4NDF8MA&ixlib=rb-4.1.0&q=80&w=900",
};

const preselect = (spaceType, profile) => {
  window.dispatchEvent(new CustomEvent("dimora:preselect", { detail: { space_type: spaceType, profile } }));
  const target = document.querySelector("#devis");
  if (window.__lenis && target) window.__lenis.scrollTo(target, { offset: -70, duration: 1.4 });
  else target?.scrollIntoView({ behavior: "smooth" });
};

const GROUPS = [
  {
    id: "particuliers",
    testid: "services-group-particuliers",
    label: "Pour les particuliers",
    cards: [
      {
        id: "logements",
        testid: "bento-service-card-coproprietes",
        icon: Home,
        title: "Ménage de logements",
        img: IMG.logement,
        points: ["Interventions régulières ou ponctuelles", "Pièces de vie, cuisine, sanitaires", "Adapté à votre rythme de vie"],
      },
      {
        id: "vitres",
        testid: "bento-service-card-vitres",
        icon: PanelTop,
        title: "Vitres",
        img: IMG.vitres,
        points: ["Vitres et baies vitrées", "Vérandas et portes-fenêtres", "Finition sans trace"],
      },
      {
        id: "automobile",
        testid: "service-card-automobile-particuliers",
        icon: Car,
        title: "Nettoyage automobile",
        tag: "Nouveau",
        img: IMG.auto,
        points: ["Nettoyage intérieur des véhicules", "Aspiration et nettoyage des surfaces", "Nettoyage des vitres intérieures"],
        cta: { label: "Demander un devis automobile", testid: "cta-devis-auto-particuliers", space: "automobile", profile: "particulier" },
      },
      {
        id: "chantier",
        testid: "service-card-chantier-particuliers",
        icon: HardHat,
        title: "Fin de chantier & remise en état",
        img: IMG.chantier,
        points: ["Dépoussiérage après travaux", "Sols, surfaces, vitres et menuiseries", "Remise en propreté avant livraison"],
        note: "Périmètre défini selon l'état du chantier, la surface et les travaux réalisés.",
        cta: { label: "Demander un devis fin de chantier", testid: "cta-devis-chantier-particuliers", space: "chantier", profile: "particulier" },
      },
    ],
  },
  {
    id: "professionnels",
    testid: "services-group-professionnels",
    label: "Pour les professionnels",
    cards: [
      {
        id: "locaux",
        testid: "bento-service-card-bureaux",
        icon: Building2,
        title: "Entretien de locaux",
        tag: "Le plus demandé",
        img: IMG.locaux,
        points: ["Bureaux, commerces et locaux professionnels", "Prestations régulières ou ponctuelles", "Respect de votre cahier des charges"],
      },
      {
        id: "vitres-pro",
        testid: "service-card-vitres-professionnels",
        icon: PanelTop,
        title: "Vitres & façades",
        img: IMG.vitres,
        points: ["Vitrines de commerce", "Baies vitrées et façades vitrées", "Passages planifiés selon votre activité"],
      },
      {
        id: "chantier-pro",
        testid: "service-card-chantier-professionnels",
        icon: HardHat,
        title: "Fin de chantier",
        img: IMG.chantier,
        points: ["Pour les professionnels du bâtiment", "Dépoussiérage, sols, vitres et menuiseries", "Remise en propreté avant livraison"],
        note: "Périmètre défini selon l'état du chantier, la surface et les travaux réalisés.",
        cta: { label: "Demander un devis fin de chantier", testid: "cta-devis-chantier-professionnels", space: "chantier", profile: "professionnel" },
      },
      {
        id: "automobile-pro",
        testid: "service-card-automobile-professionnels",
        icon: Car,
        title: "Véhicules & flottes",
        img: IMG.auto,
        points: ["Intérieur de véhicules professionnels", "Flottes, selon les capacités de DIMORA", "Aspiration, surfaces et vitres intérieures"],
        cta: { label: "Demander un devis automobile", testid: "cta-devis-auto-professionnels", space: "automobile", profile: "professionnel" },
      },
    ],
  },
];

const ServiceCard = ({ card, index }) => (
  <motion.div
    data-testid={card.testid}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay: (index % 4) * 0.08 }}
    whileHover={{ y: -6, transition: { duration: 0.3 } }}
    className="group relative overflow-hidden rounded-3xl border border-white/10 bg-[#111723]/75 card-glow flex flex-col transition-colors duration-500 hover:border-amber-400/40"
  >
    <div className="relative h-44 overflow-hidden">
      <img
        src={card.img}
        alt={card.title}
        loading="lazy"
        className="w-full h-full object-cover opacity-70 transition-all duration-700 group-hover:opacity-90 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#111723] to-transparent" />
      {card.tag && (
        <span className="absolute top-4 right-4 text-[10px] uppercase tracking-[0.2em] font-bold text-[#0A0D14] bg-amber-400 rounded-full px-3 py-1">
          {card.tag}
        </span>
      )}
      <span className="absolute bottom-4 left-6 inline-flex items-center justify-center w-11 h-11 rounded-2xl bg-[#0A0D14]/80 backdrop-blur border border-amber-400/30 text-amber-300">
        <card.icon className="w-5 h-5" strokeWidth={1.5} />
      </span>
    </div>
    <div className="p-6 sm:p-7 flex flex-col flex-1">
      <h3 className="font-display text-xl font-semibold text-white">{card.title}</h3>
      <ul className="mt-4 space-y-2.5 flex-1">
        {card.points.map((p) => (
          <li key={p} className="flex items-start gap-2.5 text-sm text-slate-300">
            <Check className="w-4 h-4 text-amber-400 mt-0.5 shrink-0" strokeWidth={2} /> {p}
          </li>
        ))}
      </ul>
      {card.note && <p className="mt-4 text-xs text-slate-500 italic leading-relaxed">{card.note}</p>}
      {card.cta ? (
        <button
          data-testid={card.cta.testid}
          onClick={() => preselect(card.cta.space, card.cta.profile)}
          className="group/btn mt-6 inline-flex items-center justify-center gap-2 rounded-full border border-amber-400/50 text-amber-200 py-3 px-5 text-xs font-bold transition-all duration-300 hover:bg-amber-400/10 hover:border-amber-300 active:scale-[0.98]"
        >
          {card.cta.label}
          <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5" />
        </button>
      ) : (
        <a
          href="#devis"
          data-testid={`${card.testid}-link`}
          className="mt-6 inline-flex items-center gap-2 text-xs font-bold text-amber-300 hover:text-amber-200 transition-colors"
        >
          Demander un devis
          <ArrowUpRight className="w-4 h-4" />
        </a>
      )}
    </div>
  </motion.div>
);

export const Services = () => (
  <section id="services" data-testid="services-section" className="relative py-28 sm:py-36">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-16"
      >
        <p className="text-xs uppercase tracking-[0.25em] text-amber-400 font-semibold mb-4">Nos prestations</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white max-w-2xl">
          Des services pensés pour <span className="text-amber-300">chaque clientèle</span>
        </h2>
      </motion.div>

      {GROUPS.map((group) => (
        <div key={group.id} data-testid={group.testid} className="mb-16 last:mb-0">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6 }}
            className="flex items-center gap-4 mb-8"
          >
            <span className="h-px w-10 bg-amber-400/70" />
            <h3 className="text-sm uppercase tracking-[0.25em] font-bold text-amber-300">{group.label}</h3>
          </motion.div>
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5">
            {group.cards.map((card, i) => (
              <ServiceCard key={`${group.id}-${card.id}`} card={card} index={i} />
            ))}
          </div>
        </div>
      ))}
    </div>
  </section>
);
